import { ExternalLink } from 'lucide-react';
import { EXTERNAL_LINK_PROPS, getAppLinkByIntegration } from '../lib/appLinks';

interface OpenAppLinkProps {
  integrationKey: string;
  className?: string;
}

function OpenAppLink({
  integrationKey,
  className = 'inline-flex items-center gap-1 text-xs font-medium text-zt-primary hover:text-zt-accent',
}: OpenAppLinkProps) {
  const link = getAppLinkByIntegration(integrationKey);
  if (!link) return null;

  return (
    <a href={link.url} {...EXTERNAL_LINK_PROPS} className={className}>
      Open app <ExternalLink size={12} />
    </a>
  );
}

export default OpenAppLink;
